var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteCartIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: ".75vw",
    height: ".75vw",
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.96791 13.469C6.55506 13.469 7.03103 12.993 7.03103 12.4059C7.03103 11.8188 6.55506 11.3428 5.96791 11.3428C5.38076 11.3428 4.90479 11.8188 4.90479 12.4059C4.90479 12.993 5.38076 13.469 5.96791 13.469Z",
    stroke: "#FCFAFA",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6002 13.469C11.1874 13.469 11.6634 12.993 11.6634 12.4059C11.6634 11.8188 11.1874 11.3428 10.6002 11.3428C10.0131 11.3428 9.53711 11.8188 9.53711 12.4059C9.53711 12.993 10.0131 13.469 10.6002 13.469Z",
    stroke: "#FCFAFA",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.50375 3.97188L4.76 7.94938C4.95313 8.56063 5.04938 8.86625 5.235 9.0925C5.3975 9.2925 5.60938 9.44688 5.84875 9.5425C6.12063 9.65063 6.44063 9.65063 7.08188 9.65063H9.49125C10.1325 9.65063 10.4525 9.65063 10.7238 9.5425C10.9638 9.44688 11.175 9.2925 11.3381 9.0925C11.5231 8.86625 11.6194 8.56063 11.8131 7.94938L12.0688 7.13938L12.2188 6.66063L12.4256 6.00438C12.4995 5.77031 12.5171 5.52215 12.4771 5.28C12.4372 5.03785 12.3408 4.80851 12.1956 4.61057C12.0505 4.41263 11.8608 4.25166 11.6419 4.1407C11.423 4.02973 11.1811 3.9719 10.9356 3.97188H3.50375ZM3.50375 3.97188L3.49688 3.94875C3.47048 3.86035 3.4413 3.77281 3.40938 3.68625C3.28284 3.36596 3.06827 3.08801 2.79045 2.88452C2.51264 2.68102 2.18291 2.56028 1.83938 2.53625C1.775 2.53125 1.70438 2.53125 1.5625 2.53125",
    stroke: "#FCFAFA",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteCartIcon);
export default __webpack_public_path__ + "static/media/WhiteCartIcon.d5b9af816c015bb348ee8a3dc516f74f.svg";
export { ForwardRef as ReactComponent };